/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum WarmingQuestionFieldMap {
  candidateAvailabilityNotes = "candidateAvailabilityNotes",
  candidateExperienceNotes = "candidateExperienceNotes",
  candidateExploringOutsideRoles = "candidateExploringOutsideRoles",
  candidatePlannedTimeOffNotes = "candidatePlannedTimeOffNotes",
  hasNoConflictOfInterest = "hasNoConflictOfInterest",
}

export const WarmingQuestionFieldMapDisplay: Record<WarmingQuestionFieldMap, string> = {
  [WarmingQuestionFieldMap.candidateAvailabilityNotes]: "Candidate Availability Notes",
  [WarmingQuestionFieldMap.candidateExperienceNotes]: "Candidate Experience Notes",
  [WarmingQuestionFieldMap.candidateExploringOutsideRoles]: "Candidate Exploring Outside Roles",
  [WarmingQuestionFieldMap.candidatePlannedTimeOffNotes]: "Candidate Planned Time Off Notes",
  [WarmingQuestionFieldMap.hasNoConflictOfInterest]: "Has No Conflict Of Interest",
};
